<template>
  <div id="sidebar-clients-btn">
    <v-btn
      block
      variant="elevated"
      rounded="sm"
      prepend-icon="mdi-magnify"
      @click="openClients"
    >
      Clients
    </v-btn>
  </div>
</template>

<script setup>
import { useClientStore } from "./../../../stores/clientStore";

const clientStore = useClientStore();

function openClients() {
  clientStore.openClientModal();
}
</script>

<style scoped>
#sidebar-clients-btn {
  margin-bottom: 8px;
}
</style>
